﻿import { version } from "moment";

(function () {
    'use strict';

    var controllerId = 'serviceTimeShipper';
    const _CATEGORYNAME = "TiempoAtencionSugeridaTipoOperacion";
    angular.module('app.controllers').controller(controllerId, serviceTimeShipper)

    serviceTimeShipper.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams', '$translate'];

    function serviceTimeShipper(common, datacontext, $http, $scope, $stateParams, $translate) {
        let vm = this;
        vm.validFamilies = ['DRY', 'REF'];
        vm.validOperationTypes = [];
        vm.gridTitle = [];
        vm.additionalInfo = [];
        vm.yardOperationConfigurations = [];
        vm.listDepots = [];
        vm.listFamilies = [];
        vm.listOperationTypes = [];
        vm.listOperationTypesFull = [];
        function init() {
            vm.initCriteria();
            vm.initData();
        }

        vm.initData = function () {
            //LOAD APPLICATION SETTINGS FOR OPERATIONS BY GATE
            datacontext.servicetime.getApplicationSettingValueByCategory(_CATEGORYNAME).then(function (value) {
                if (value) {
                    vm.yardOperationConfigurations = value;
                    vm.getGeneralFilters();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });

            vm.gridDataSource = new kendo.data.DataSource({
                data: []
            });

            vm.gridOptions = {
                dataSource: vm.gridDataSource,
                sortable: false,
                pageable: false,
                groupable: false,
                columns: [
                    {
                        title: $translate.instant('views.serviceTimeShipper.tract'),
                        field: "Interval",
                        width: "16%",
                        attributes: {
                            "style": "text-align: center;",
                             class: "cellInBold"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                             class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.serviceTimeShipper.current'),
                        field: "Today",
                        width: "12%",
                        attributes: {
                            "style": " text-align: center;"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        field: "D2",
                        width: "12%",
                        headerTemplate:kendo.template($("#D2").html()),
                        attributes: {
                            "style": " text-align: center;",
                            class: "gridTimes"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        field: "D3",
                        width: "12%",
                        headerTemplate:kendo.template($("#D3").html()),
                        attributes: {
                            "style": " text-align: center;",
                            class: "gridTimes"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        field: "D4",
                        width: "12%",
                        headerTemplate:kendo.template($("#D4").html()),
                        attributes: {
                            "style": " text-align: center;",
                            class: "gridTimes"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        field: "D5",
                        width: "12%",
                        headerTemplate:kendo.template($("#D5").html()),
                        attributes: {
                            "style": " text-align: center;",
                            class: "gridTimes"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        field: "D6",
                        width: "12%",
                        headerTemplate:kendo.template($("#D6").html()),
                        attributes: {
                            "style": " text-align: center;",
                            class: "gridTimes"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        field: "D7",
                        width: "12%",
                        headerTemplate:kendo.template($("#D7").html()),
                        attributes: {
                            "style": " text-align: center;",
                            class: "gridTimes"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        field:"D2Availability",
                        hidden: true,
                        attributes:{
                            class: "hiddenTimes"
                        }
                    },
                    {
                        field:"D3Availability",
                        hidden: true,
                        attributes:{
                            class: "hiddenTimes"
                        }
                    },
                    {
                        field:"D4Availability",
                        hidden: true,
                        attributes:{
                            class: "hiddenTimes"
                        }
                    },
                    {
                        field:"D5Availability",
                        hidden: true,
                        attributes:{
                            class: "hiddenTimes"
                        }
                    },
                    {
                        field:"D6Availability",
                        hidden: true,
                        attributes:{
                            class: "hiddenTimes"
                        }
                    },
                    {
                        field:"D7Availability",
                        hidden: true,
                        attributes:{
                            class: "hiddenTimes"
                        }
                    }
                ]
            };
        }

        vm.getGeneralFilters = function () {
            return datacontext.servicetime.getFilters(vm.roleSelected).then(function (data) {
                if (data) {
                    if (data.Depot != null && data.Depot.length > 0) {
                        vm.listDepots = data.Depot;
                        vm.criteria.yardId = vm.listDepots[0].Id;
                    }

                    if (data.FamilyList != null && data.FamilyList.length > 0) {
                        angular.forEach(data.FamilyList, function (family, key) {
                            family.label = family.Name;
                            family.id = family.Id;
                            if (vm.validFamilies.indexOf(family.Code) != -1) {
                                vm.listFamilies.push(family);
                                vm.criteria.familyIds.push(family);
                            }
                        });
                    }

                    vm.getOperationTypes();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.getOperationTypes = function () {
            if(vm.listOperationTypesFull.length == 0){
                return datacontext.servicetimeshipper.getTransactionTypes().then(function (data) {
                    if (data) {                  
                        angular.forEach(data, function (value, key) {
                            vm.listOperationTypesFull.push(value);
                        });
                        vm.setOperationType();
                    }
                
                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
            }else{
                vm.setOperationType();
            }
        }

        vm.setOperationType = function () {
            vm.listOperationTypes = [];
            var currentYard= $(vm.listDepots).filter(function (a, b) { return b.Id == vm.criteria.yardId });
            var currentConfiguration= $(vm.yardOperationConfigurations).filter(function (a, b) { return b.Code == currentYard[0].Code });
            if(currentConfiguration.length > 0){
                vm.validOperationTypes = currentConfiguration[0].Aditional.split(',');
                angular.forEach(vm.listOperationTypesFull, function (value, key) {
                    if (vm.validOperationTypes.indexOf(value.Code) != -1) {
                        vm.listOperationTypes.push(value);
                    }
                });
            }else{
                angular.forEach(vm.listOperationTypesFull, function (value, key) {
                        vm.listOperationTypes.push(value);
                });
            }
            vm.criteria.transactionTypeId =vm.listOperationTypes[0].Id;
        }

        vm.getCurrentOperationTypeCode = function () {
            var currentOperation = $(vm.listOperationTypes).filter(function (a, b) { return b.Id == vm.criteria.transactionTypeId });
            if (currentOperation.length > 0) {
                    return currentOperation[0].Code;
            }else{
                    return null;
            }
        }

        vm.searchReport = function () {
            var valid = true;

            if (vm.criteria.familyIds.length == 0) {
                toastr.info($translate.instant('views.serviceTimeShipper.familyRequired'));
                valid = false;
            }

            if (!valid){
                return;
            }

            var criteria = {
                YardId: vm.criteria.yardId,
                TransactionTypeId: vm.criteria.transactionTypeId,
                EquipmentFamilyIds:vm.GetIdsFromMultiSelectList(vm.criteria.familyIds).join(",")
            };

            datacontext.servicetimeshipper.getServiceTimeShipperList(criteria).then(function(data){
                if (data){
                    vm.gridTitle = data.Days;
                    vm.gridDataSource = {data:data.Schedule};
                    vm.additionalInfo = data.AdditionalInfo;
                    vm.setTitles();

                    vm.refresReport();

                    setTimeout(function(){
                        
                        var maximunAvailability =  vm.additionalInfo.MaximunAvailability;
                        var minimumAverage = vm.additionalInfo.MinimunAverage;
                        
                        $.each($(".hiddenTimes"), function( k, v ) {
                            if(v.innerText != null && maximunAvailability > 0 && v.innerText == maximunAvailability){
                                var average = $(".gridTimes")[k].innerText;
                                if (average != null && average == minimumAverage)
                                    $($(".gridTimes")[k]).addClass("k-green");
                            }
                        });
                        
                    },100);

                }else{
                    vm.clearReport();
                }
            }, function(error){
                if (error.status)
                    toastr.error(error.info);
            });

        };

        vm.GetIdsFromMultiSelectList = function (selectedItems) {
            var ids = [];
            angular.forEach(selectedItems, function (val, key) { ids.push(val.id); });
            return ids;
        }

        vm.setTitles = function(){
                var grid = $("#mainReport").data("kendoGrid");
                
                for(var i=0;i< 7 ;i++){
                    grid.showColumn(i);
                }

                if(vm.gridTitle.length > 1){
                    $('#titleD2').text($translate.instant('views.serviceTimeShipper.' + vm.gridTitle[1].DayCode.toLowerCase()));
                    $('#titleD3').text($translate.instant('views.serviceTimeShipper.' + vm.gridTitle[2].DayCode.toLowerCase()));
                    $('#titleD4').text($translate.instant('views.serviceTimeShipper.' + vm.gridTitle[3].DayCode.toLowerCase()));
                    $('#titleD5').text($translate.instant('views.serviceTimeShipper.' + vm.gridTitle[4].DayCode.toLowerCase()));
                    $('#titleD6').text($translate.instant('views.serviceTimeShipper.' + vm.gridTitle[5].DayCode.toLowerCase()));
                    $('#titleD7').text($translate.instant('views.serviceTimeShipper.' + vm.gridTitle[6].DayCode.toLowerCase()));
                }else{
                    $('#titleD2').text("");
                    $('#titleD3').text("");
                    $('#titleD4').text("");
                    $('#titleD5').text("");
                    $('#titleD6').text("");
                    $('#titleD7').text("");
                }
            for(var i=0; i<vm.gridTitle.length; i++){
                if (vm.gridTitle[i].Advice > 0){
                    grid.hideColumn(i+1);
                }
            }
        };

        vm.clearReport = function () {
            vm.gridDataSource = { data: [] };
            vm.initCriteria();
            vm.setOperationType();
        };

        vm.initCriteria = function () {
            vm.criteria = {
                yardId: vm.listDepots ? (vm.listDepots.length > 0 ? vm.listDepots[0].Id : 0) : 0,
                transactionTypeId: 0,
                familyIds: [],
            };
            angular.forEach(vm.listFamilies, function (family, key) {
                vm.criteria.familyIds.push(family);
            });
            vm.refresReport();
        }

        vm.refresReport = function () {
            var mainReport = angular.element('#mainReport').data("kendo-grid");
            if (mainReport) {
                mainReport.refresh();
            }
        }

        vm.selectYard= function () {
            vm.setOperationType();
        }

        vm.getIdsFromMultiSelectList = function (selectedItems) {
            var ids = [];
            angular.forEach(selectedItems, function (val, key) { ids.push(val.id); });
            return ids;
        }

        init();

    }

})();
